import type { AudienceListType, SegmentTreeNode } from '../../../../../../../modules/audiences/AudienceForm/types.ts';
import { TreeNode } from './TreeNode.tsx';

type BaseTraverseProps = {
  node: SegmentTreeNode;
  prefix: string[];
  type: AudienceListType;
};

type TraverseProps =
  | (BaseTraverseProps & { readOnly: true })
  | (BaseTraverseProps & { readOnly?: false; onLeafDelete: (node: SegmentTreeNode) => void });

export const TraverseNode = ({ node, prefix, type, ...rest }: TraverseProps) => {
  const currentPath = [...prefix, node.name];
  const children = node.children ?? [];

  const isLeaf = children.length === 0;
  const isLeafGroup = children.length > 0 && children.every(c => (c.children ?? []).length === 0);

  if (isLeafGroup) {
    return <TreeNode node={node} path={currentPath} type={type} {...rest} />;
  }

  if (isLeaf) {
    return null;
  }

  return (
    <>
      {children.map(child => (
        <TraverseNode key={child.id} node={child} prefix={currentPath} type={type} {...rest} />
      ))}
    </>
  );
};
